/* @flow */

// PATHS
export const API_DOMAIN_VAGRANT: string = 'http://er-dev.com';
export const API_DOMAIN_INTERNAL_STAGING: string = 'https://electrorent-api.dntlss.com/api/v1';

/**
 * @see /scripts/build-check-env-vars.js
 * @see github.com/facebook/create-react-app/tree/v1.0.17/packages/react-scripts/template#adding-custom-environment-variables
 */
export const API_DOMAIN: string = (process.env.REACT_APP_API_DOMAIN: any); // eslint-disable-line
export const VERSION_NUMBER = process.env.REACT_APP_VERSION_NUMBER;
export const BUILD_NUMBER = process.env.REACT_APP_BUILD_NUMBER;

export const TERMS_OF_BUSINESS_URL: string = (process.env.REACT_APP_TERMS_OF_BUSINESS_URL: any); // eslint-disable-line
export const TERMS_OF_USE_URL: string = (process.env.REACT_APP_TERMS_OF_USE_URL: any); // eslint-disable-line
export const PRIVACY_POLICY_URL: string = (process.env.REACT_APP_PRIVACY_POLICY_URL: any); // eslint-disable-line
export const EULA_URL: string = (process.env.REACT_APP_EULA_URL: any); // eslint-disable-line

export const API_PATH: string = `${API_DOMAIN}/api/v1`;
export const OAUTH_PATH: string = `${API_PATH}/user/login`;

export const APPLICATION_INSIGHTS_KEY =
  process.env.REACT_APP_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY;

// OAUTH PROPERTIES
export const CLIENT_SECRET: string = (process.env.REACT_APP_OAUTH_CLIENT_SECRET: any); // eslint-disable-line
export const CLIENT_ID: string = (process.env.REACT_APP_OAUTH_CLIENT_ID: any); // eslint-disable-line
export const GRANT_TYPE: string = 'password';

export type Environment = 'development' | 'qa' | 'uat' | 'staging' | 'demo' | 'production';

const resolveEnvironment = (): Environment => {
  switch (process.env.REACT_APP_ENV) {
    case 'development':
    case 'qa':
    case 'uat':
    case 'staging':
    case 'demo':
    case 'production':
      return process.env.REACT_APP_ENV;

    default:
      return 'development';
  }
};
export const ENV = resolveEnvironment();
